import { createAsyncThunk } from '@reduxjs/toolkit';

import { client } from '../../../graphql/client';
import { REOPEN_ROUTE } from '../../../graphql/requests/reopenRoute';
import {
  GRouteReopenInput,
  GRouteReopenPayload,
} from '../../../graphql/types/generated';
import analytics from '../../../services/analytics';
import { hideModal, setIsModalLoading } from '../modal';
import { NotificationType, showNotification } from '../notification';
import { getRoutes } from './getRoutes';

export const reopenRoute = createAsyncThunk<
  GRouteReopenPayload | null,
  GRouteReopenInput & {
    warehouseId: string;
    nightEnd: string;
  }
>(
  'delivery/reopenRoute',
  async (
    input: GRouteReopenInput & {
      warehouseId: string;
      nightEnd: string;
    },
    thunkAPI,
  ): Promise<GRouteReopenPayload | null> => {
    thunkAPI.dispatch(setIsModalLoading(true));
    const { data, error } = await client
      .mutation(REOPEN_ROUTE, {
        input: { deliveryRouteId: input.deliveryRouteId },
      })
      .toPromise();
    thunkAPI.dispatch(setIsModalLoading(false));
    thunkAPI.dispatch(hideModal());
    if (error || !data.reopenRoute || data.reopenRoute.userErrors.length > 0) {
      analytics.track('Reopen Route Failed', {
        routeId: input.deliveryRouteId,
      });
      thunkAPI.dispatch(
        showNotification({
          type: NotificationType.Error,
          message: 'Failed to unmark the route as completed. Please try again.',
        }),
      );
      return null;
    }
    analytics.track('Reopen Route', {
      routeId: input.deliveryRouteId,
    });
    thunkAPI.dispatch(
      showNotification({
        type: NotificationType.Success,
        message:
          'Route has been unmarked as completed. Stops can be edited again.',
      }),
    );
    thunkAPI.dispatch(
      getRoutes({
        warehouseId: input.warehouseId,
        nightEnd: input.nightEnd,
      }),
    );
    return data.reopenRoute;
  },
);
